import axiosInstance from 'axiosInstance';

export const fetchBlogPosts = async () => {
  const response = await axiosInstance.get('login/blog-posts');
  return response.data;
};

export const fetchBlogPost = async postId => {
  const response = await axiosInstance.get(`login/blog-posts/${postId}`);
  return response.data;
};

export const createBlogPost = async payload => {
  const response = await axiosInstance.post('login/blog-posts', payload);
  return response.data;
};

export const updateBlogPost = async (postId, payload) => {
  const response = await axiosInstance.post(`login/blog-posts/${postId}`, payload);
  return response.data;
};

export const uploadBlogImage = async file => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axiosInstance.post('login/blog-posts/upload-image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const fetchPublicBlogPosts = async () => {
  const response = await axiosInstance.get('login/blog-posts/public');
  return response.data;
};

export const fetchPublicBlogPostBySlug = async slug => {
  const response = await axiosInstance.get(`login/blog-posts/public/${slug}`);
  return response.data;
};
